const telephoneTypeByValue = (type, contactTypes) => {
    var _a;
    return (_a = contactTypes.find(({ value }) => type === value)) === null || _a === void 0 ? void 0 : _a.name;
};
export default telephoneTypeByValue;
